<template>
    <v-simple-table>
        <thead style="background: #FF5100">
        <tr>
            <th class="tableTxt pa-2">{{ $t('page.data-stat.industry') }}</th>
            <th class="tableTxt pa-2">{{ unit }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in data" :key="index">
            <td class="text-left pl-5" style="font-size: 18px">{{ (index+1) + '. ' + row[`label_${language}`] }}</td>
            <td style="font-size: 18px">{{ formatNumber(row.value) }}</td>
        </tr>
        </tbody>

        <tr id="total" style="background: #507CD6">
            <td class="text-right"><span class="tableTotal">{{ $t('general.total-value') }} :</span></td>
            <td><span class="tableTotal">{{ formatNumber(sum) }}</span></td>
        </tr>
    </v-simple-table>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "TwoColumnsTableData",
        props: ['data', 'unit'],
        computed: {
            ...mapState({
                language: state => state.locale.language,
            }),
            sum: function () {
                const total = this.data.reduce((carry, item) => carry + parseFloat(item.value), 0)

                return total
            }
        },
        methods: {
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },
        },
    }
</script>

<style scoped>

    .tableTotal {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
    }

    .v-application--is-ltr .v-data-table th {
        text-align: center;
    }

    .tableTxt {
        font-size: 17px;
        color: #fff !important;
    }

    /* table border style */
    .theme--light.v-data-table tbody tr td {
        border-bottom: 1px solid #FF5100 !important;
    }

    .theme--light.v-data-table tbody tr td:not(:last-child) {
        border-right: 1px solid #FF5100;
    }

    .theme--light.v-data-table thead tr:last-child th:not(:last-child) {
        border-right: 1px solid #fff;
    }

    .theme--light.v-data-table tr#total td:nth-child(1) {
        border-right: 1px solid #fff;
    }
    /* end table border style */

</style>
